t = require('views/internal/teacup-with-helpers')()

module.exports = t.renderable ->
  t.div '.product-promo-disable-overlay'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/product_promo_disable_overlay.coffee